<template>
  <div class="month-selection" :class="{ mobile: isMobile }">
    <Dropdown @on-click="changeMonth" trigger="click">
      <div
        class="month-selection__button"
        :class="{ 'btn btn-outline-dark': !isMobile }"
      >
        <fa icon="calendar-alt"></fa>
        <span v-if="!isMobile">
          {{ month === 'this' ? 'Latest 30 days' : 'Latest 60 days' }}
        </span>
        <fa icon="caret-down"></fa>
      </div>
      <DropdownMenu slot="list">
        <DropdownItem name="this" class="ga__monthly-picker">
          Latest 30 days
        </DropdownItem>
        <DropdownItem name="last" class="ga__monthly-picker">
          Latest 60 days
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
      showDatepicker: false,
      dateRange: ''
    };
  },
  computed: {
    ...mapGetters(['isMobile']),
    ...mapGetters('dataStore', ['month'])
  },
  watch: {
    month(newVal, oldVal) {
      if (newVal === 'this' || newVal === 'last') {
        this.dateRange = '';
      }
    }
  },
  methods: {
    ...mapActions('dataStore', ['changeMonth']),
    showDatePicker() {
      this.showDatepicker = !this.showDatepicker;
    }
  }
};
</script>

<style lang="scss">
.month-selection {
  &__button {
    border: 1px solid #1a1a1a;
    padding: 0 0.5rem;
    height: 2.5rem;
    line-height: 2.5rem;
    color: #1a1a1a;
    background: white;
    font-size: 1rem;
    cursor: pointer;

    span {
      margin-right: 6px;
    }
  }

  ul {
    margin-bottom: 0;
  }

  .btn-month {
    margin: 0 5px;
    @include light-shadow;
    transition: all 0.5s;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;

    &:hover {
      background-color: $apnic-blue;
      color: white !important;
    }

    &.btn-primary {
      color: white !important;
    }
  }

  .ivu-btn:focus {
    box-shadow: none !important;
  }

  .ivu-dropdown {
    .ivu-select-dropdown {
      width: 10rem;
      border: solid 1px rgba(0, 0, 0, 0.15);
      border-radius: 0;
      box-shadow: none;
      margin: 2px 0;

      .ivu-dropdown-item {
        font-size: 16px !important;

        &:hover {
          background: #e6e6e6;
        }
      }
    }
  }
}

.mobile.month-selection {
  .month-selection__button {
    width: 3.5rem;

    svg:nth-of-type(2) {
      display: inline-block;
      margin-left: 0.5rem;
    }
  }
}
</style>
